import { RoleName } from "consts/auth";
import { WebRoutes } from "consts/enpoints/web";

export const routes = {
    [WebRoutes.Root]: {
        path: WebRoutes.Root,
        roles: [
            RoleName.MerchantAdmin,
            RoleName.MerchantEmployee,
            RoleName.MerchantsAgent,
            RoleName.MerchantFinance,
            RoleName.MerchantTech,
            RoleName.OnboardingE,
            RoleName.OnboardingO
        ]
    },
    [WebRoutes.Dashboard]: {
        path: WebRoutes.Dashboard,
        roles: [
            RoleName.MerchantAdmin,
            RoleName.MerchantEmployee,
            RoleName.MerchantsAgent,
            RoleName.MerchantFinance,
            RoleName.MerchantTech
        ]
    },
    [WebRoutes.Transactions]: {
        path: WebRoutes.Transactions,
        roles: [
            RoleName.MerchantAdmin,
            RoleName.MerchantsAgent,
            RoleName.MerchantFinance,
            RoleName.MerchantTech
        ]
    },
    [WebRoutes.Consumers.Index]: {
        path: WebRoutes.Consumers.Index,
        roles: [
            RoleName.MerchantAdmin
        ]
    },
    [WebRoutes.Consumers.WhiteListed]: {
        path: WebRoutes.Consumers.WhiteListed,
        roles: [
            RoleName.MerchantAdmin
        ]
    },
    [WebRoutes.Finance.Index]: {
        path: WebRoutes.Finance.Index,
        roles: [
            RoleName.MerchantAdmin,
            RoleName.MerchantFinance
        ]
    },
    [WebRoutes.Finance.Settlements]: {
        path: WebRoutes.Finance.Settlements,
        roles: [
            RoleName.MerchantAdmin,
            RoleName.MerchantFinance
        ]
    },
    [WebRoutes.Finance.SummaryFiles]: {
        path: WebRoutes.Finance.SummaryFiles,
        roles: [
            RoleName.MerchantAdmin,
            RoleName.MerchantFinance
        ]
    },
    [WebRoutes.Profile]: {
        path: WebRoutes.Profile,
        roles: [
            RoleName.MerchantAdmin,
            RoleName.MerchantsAgent,
            RoleName.MerchantFinance,
            RoleName.MerchantTech
        ]
    },
    [WebRoutes.Users]: {
        path: WebRoutes.Users,
        roles: [
            RoleName.MerchantAdmin
        ]
    },
    [WebRoutes.Support]: {
        path: WebRoutes.Support,
        roles: [
            RoleName.MerchantAdmin,
            RoleName.MerchantEmployee,
            RoleName.MerchantsAgent,
            RoleName.MerchantFinance,
            RoleName.MerchantTech,
            RoleName.OnboardingE,
            RoleName.OnboardingO
        ]
    },
    [WebRoutes.PaymentMethods]: {
        path: WebRoutes.PaymentMethods,
        roles: [
            RoleName.MerchantAdmin
        ]
    }
};

export default routes;
